import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MailmergeHeaderCellComponent } from './header-cell.component';
import { NoDuplicateModule } from '@schoolbelle/common/no-duplicate';
import { RestrictedModule } from './restricted/restricted.module';


@NgModule({
  declarations: [MailmergeHeaderCellComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    NoDuplicateModule, RestrictedModule,
  ],
  exports:[MailmergeHeaderCellComponent],
})
export class MailmergeHeaderCellModule { }
